import React, { FunctionComponent, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { CheckboxButtonType } from '@lyrahealth-inc/shared-app-logic/src/models/formMetadata/FormMetadata'
import { Checkbox } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/formElements/Checkbox'
import { ConfirmationModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/confirmationModal/ConfirmationModal'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

export interface MarkRiskAddressedModalProps {
  visible: boolean
  onConfirm: (keepBadgeVisible: boolean) => void
  onClose: () => void
  confirmLoading?: boolean
}

export const MarkRiskAddressedModal: FunctionComponent<MarkRiskAddressedModalProps> = ({
  visible,
  onConfirm,
  onClose,
  confirmLoading = false,
}) => {
  const intl = useIntl()
  const [keepBadgeVisible, setKeepBadgeVisible] = useState(false)

  const handleConfirm = () => {
    onConfirm(keepBadgeVisible)
  }

  const handleClose = () => {
    setKeepBadgeVisible(false)
    onClose()
  }

  return (
    <ConfirmationModal
      testID={tID('MarkRiskAddressedModal')}
      visible={visible}
      modalTitle={
        <FormattedMessage
          defaultMessage='Mark risk as addressed'
          description='Title for the mark risk as addressed confirmation modal'
        />
      }
      modalContents={
        <>
          <FormattedMessage
            defaultMessage='Ensure all necessary outreach and documentation is complete.'
            description='Body text for the mark risk as addressed confirmation modal'
          />
          <Checkbox
            testID={tID('MarkRiskAddressedModal-keepBadgeCheckbox')}
            buttonType={CheckboxButtonType.CHECKBOX_DESCRIPTION_NO_OUTLINE}
            title={intl.formatMessage({
              defaultMessage: 'Keep risk badge visible',
              description: 'Checkbox title to keep risk badge visible after marking addressed',
            })}
            description={intl.formatMessage({
              defaultMessage: 'Check this if the client requires continued attention.',
              description: 'Checkbox description for keeping the risk badge visible',
            })}
            checked={keepBadgeVisible}
            onPress={() => setKeepBadgeVisible((prev) => !prev)}
          />
        </>
      }
      confirmationButtonText={
        <FormattedMessage
          defaultMessage='Confirm'
          description='Confirm button text for the mark risk as addressed modal'
        />
      }
      onConfirmationButtonPress={handleConfirm}
      onRequestClose={handleClose}
      confirmButtonLoading={confirmLoading}
      showCancel={false}
      closeOnScrim
      width='544px'
    />
  )
}
